import session from '@/utils/session'

export const setUser = ({ commit }, data) => {
  if (data) {
    session.setSessionByObj('user', data)
  } else {
    session.removeSession('user')
  }
  commit('user', data)
}

export const setMenuTree = ({ commit }, data) => {
  if (data) {
    session.setSessionByObj('menuTree', data)
  } else {
    session.removeSession('menuTree')
  }
  commit('menuTree', data)
}

export const setMenuClickInOtherPage = ({ commit }, data) => {
  commit('menuClickInOtherPage', data)
}



// WEBPACK FOOTER //
// ./src/store/actions.js